import React, { useEffect, useState } from "react";
import CustomButton from "../../components/Button/DialogButtons";
import LoadingAnimation from "../../components/LoadingAnimation/LoadingAnimation";
import SnackbarMessage from "../../components/Snackbar";
import InputField from "../../components/FormFilelds/InputField";
import DatePickerInput from "../../components/FormFilelds/Datepicker";
import SelectInput from "../../components/FormFilelds/selectinput";
import PhoneNumberInput from "../../components/FormFilelds/PhoneNumberInput";
import { AxiosError } from "axios";
import Autocomplete from '@mui/material/Autocomplete';

import {
  MastersData,
  TimezonesData,
  UserData,
} from "../../components/interface/providerinterface";
import {
  fetchMasters,
  fetchTimezones,
  fetchUserInfo,
  updateUser,
} from "../../services/providerService";
import { useNavigate } from "react-router-dom";
import { Grid, TextField } from "@mui/material";

interface Timezone {
  id: number;
  country_code: string;
  zone_name: string;
}

interface Master {
  id: number;
  attributes: {
    phonecode: string;
    currency_code: string;
    currency_symbol: string;
  };
  master_type_slug: string;
  name: string;
  slug: string;
  is_active: number;
}


const Accounts: React.FC = () => {

  const [stateOptions, setStateOptions] = useState<{ label: string, value: string }[]>([]);
  const [userData, setUserData] = useState<UserData | null>(null);
  const [mastersData, setMastersData] = useState<MastersData | null>(null);
  const [timezonesData, setTimezonesData] = useState<TimezonesData | null>(
    null
  );
  const navigate = useNavigate();

  // Form data state
  const [id, setid] = useState("");
  const [role_id, setrole_id] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isd_code, setIsd_code] = useState("");
  const [username, setUsername] = useState("");
  const [secret, setSecret] = useState("");
  const [dob, setDob] = useState<Date | null>(null);
  const [gender, setGender] = useState("");
  const [blood_group, setBlood_group] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [country, setcountry] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [state, setState] = useState("");
  const [email, setEmail] = useState("");
  const [sms, setSms] = useState("");
  const [country_iso, setCountry_iso] = useState("");
  const [emergency_contact_info, setEmergency_contact_info] = useState("");
  const [is_2fa, setIs_2fa] = useState("");
  const [is_active, setIs_active] = useState("");
  const [selectedCountry, setSelectedCountry] = useState<{
    value: string;
  } | null>(null);
  const [selectedTimeZone, setSelectedTimeZone] = useState<{
    zone_name: string;
    country_code: string;
  } | null>(null);
  const [timezoneid, setTimezoneId] = useState();
  const [mobile, setmobile] = useState("");
  const [isdCode, setIsdCode] = useState("");
  const [role, setrole] = useState("school");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    "success" | "error" | "info"
  >("info");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isEditable, setIsEditable] = useState(false); // Initially disabled until data is loaded
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [bloodGroupError, setBloodGroupError] = useState(false);
  const [dobError, setDobError] = useState(false);
  const [genderError, setGenderError] = useState(false);
  const [addressError, setAddressError] = useState(false);
  const [address2Error, setAddress2Error] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [zipcodeError, setZipcodeError] = useState(false);
  const [stateError, setStateError] = useState(false);
  const [countryError, setCountryError] = useState(false);
  const [timeZoneError, setTimeZoneError] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [timeZones, setTimeZones] = useState<Timezone[]>([]);


  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const userResponse = await fetchUserInfo();
        console.log("User Data:", userResponse);
        setUserData(userResponse);
      } catch (err) {
        setError("Failed to load user data");
        console.error("Error fetching user data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    if (mastersData?.data) {
      const user = userData?.data;
      if (user?.address?.state) {
        setState(user.address.state); // Pre-select state from user data if available
      }

      // Find the country from mastersData based on the user's address
      const country = mastersData?.data.masters.find(
        (master) => master.name === user?.address?.country
      );

      // If country and its states exist, map states to { label, value }
      if (country && country.attributes?.states) {
        const formattedStates = country.attributes.states.map((state) => ({
          label: state,
          value: state,
        }));
        setStateOptions(formattedStates); // Set state options based on the selected country
      }
    }
  }, [mastersData, userData]);

  useEffect(() => {
    const fetchMastersData = async () => {
      setLoading(true);
      try {
        const mastersResponse = await fetchMasters();
        console.log("Masters Data:", mastersResponse);
        setMastersData(mastersResponse);
      } catch (err) {
        setError("Failed to load masters data");
        console.error("Error fetching masters data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMastersData();
  }, []);

  useEffect(() => {
    const fetchTimezonesData = async () => {
      setLoading(true);
      try {
        const timezonesResponse = await fetchTimezones();
        console.log("Timezones Data:", timezonesResponse);
        setTimezonesData(timezonesResponse);
      } catch (err) {
        setError("Failed to load timezones data");
        console.error("Error fetching timezones data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTimezonesData();
  }, []);

  useEffect(() => {
    if (userData?.data) {
      const user = userData.data;
      setid(String(user.id));
      setrole_id(user.role_id?.toString() || "");
      setFirstName(user.first_name || "");
      setLastName(user.last_name || "");
      setIsd_code(user.isd_code || "");
      setUsername(user.username || "");
      setSecret(user.secret || "");
      setDob(user.dob ? new Date(user.dob) : null);
      setBlood_group(user.blood_group || "");
      setGender(user.gender || "");
      setAddress1(user.address?.address1 || "");
      setAddress2(user.address?.address2 || "");
      setCity(user.address?.city || "");
      setcountry(user.address?.country || "");
      setZipcode(user.address?.zipcode || "");
      setState(user.address?.state || "");
      setEmail(user.email || "");
      setmobile(user.mobile || "");
      setIsdCode(user.isd_code || "");
      setrole(user.role || "");
      setSms(user.communication_channel?.sms?.toString() || "");
      setCountry_iso(user.country_iso || "");
      setEmergency_contact_info(user.emergency_contact_info || "");
      setIs_2fa(user.is_2fa?.toString() || "");
      setIs_active(user.is_active?.toString() || "");

      if (user.address?.country) {
        const userCountrySlug = user.address.country;
        setSelectedCountry({ value: user.address.country });
        const selectedCountryData = mastersData?.data.masters.find(
          (master) => master.name === userCountrySlug
        );
        handleUpdateCountryChange(userCountrySlug, selectedCountryData);
        if (user.timezone?.zone_name) {
          setSelectedTimeZone({
            zone_name: user.timezone.zone_name,
            country_code: user.timezone.country_code || "",
          });
        } else {
          setSelectedTimeZone(null);
        }
      }
      setIsEditable(true);
    }
  }, [userData, mastersData, timezonesData]);


  const handleCancel = () => {
    navigate('/home/teleconsult');
    setLoading(true);
    console.log("Cancel action");
  };
  const bloodGroupOptions = [
    { label: "A+", value: "A+" },
    { label: "A-", value: "A-" },
    { label: "B+", value: "B+" },
    { label: "B-", value: "B-" },
    { label: "AB+", value: "AB+" },
    { label: "AB-", value: "AB-" },
    { label: "O+", value: "O+" },
    { label: "O-", value: "O-" },
  ];
  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Other", value: "other" },
  ];


  const handleCountryChange = async (selectedValue: string) => {
    setSelectedTimeZone(null); // Reset timezone
    setSelectedCountry({ value: selectedValue }); // Set selected country
    setState(''); // Reset state when country changes

    // Find the country data from mastersData based on the selected country
    const selectedCountryData = mastersData?.data.masters.find(
      (master) => master.name === selectedValue
    );

    if (selectedCountryData) {
      // Handle timezones (Filter based on country code)
      if (timezonesData?.data?.timezones) {
        const timezones = Array.isArray(timezonesData.data.timezones[0])
          ? timezonesData.data.timezones[0]
          : [];
        // Filter timezones based on the country code
        const filteredTimeZones = timezones.filter(
          (zone) => zone.country_code === selectedCountryData.slug
        );
        setTimeZones(filteredTimeZones);
      } else {
        console.log('No matching timezones found.');
      }

      // Handle states (Set state options based on the selected country)
      if (selectedCountryData.attributes?.states) {
        const formattedStates = selectedCountryData.attributes.states.map((state) => ({
          label: state, // State name (displayed in UI)
          value: state, // State code (used as the actual value)
        }));
        setStateOptions(formattedStates); // Set state options based on the selected country
      } else {
        setStateOptions([]); // Reset state options if no states are found
      }
    } else {
      console.log('Selected country not found in masters data.');
    }
  };

  const handleUpdateCountryChange = async (selectedValue: any, selectedCountryData: any) => {
    console.log("Selected country:", selectedValue);
    setSelectedCountry({ value: selectedValue });

    if (selectedCountryData && timezonesData?.data?.timezones) {
      const timezones = Array.isArray(timezonesData.data.timezones[0]) ? timezonesData.data.timezones[0] : [];

      // Filter timezones based on the country code
      const filteredTimeZones = timezones.filter(
        (zone) => zone.country_code === selectedCountryData.slug
      );
      console.log('filteredTimeZones', filteredTimeZones);
      setTimeZones(filteredTimeZones);
    } else {
      console.log('No matching timezones found.');
    }
  };


  // Country options based on masters data
  const countryOptions = mastersData?.data.masters.map((master) => ({
    label: master.name || "Unknown Country", // Display country name
    value: master.slug || "0", // Use country slug as the value for consistency
  })) || [];

  // Timezone options filtered by selected country
  const timeZoneOptions = timeZones.map((zone) => ({
    value: zone.zone_name,
    label: zone.zone_name,
  }));


  if (loading) {
    return (
      <div className="flex justify-center items-center h-full bg-[#eaeaea]">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      </div>
    );
  }
  const handleSave = async () => {
    const fieldsToValidate = [
      { value: firstName, setter: setFirstNameError, message: "First name is required" },
      { value: lastName, setter: setLastNameError, message: "Last name is required" },
      { value: blood_group, setter: setBloodGroupError, message: "Blood group is required" },
      { value: dob, setter: setDobError, message: "Date of Birth is required" },
      { value: gender, setter: setGenderError, message: "Gender is required" },
      { value: address1, setter: setAddressError, message: "Address is required" },
      { value: city, setter: setCityError, message: "City is required" },
      { value: zipcode, setter: setZipcodeError, message: "Zipcode is required" },
      { value: state, setter: setStateError, message: "State is required" },
      { value: country, setter: setCountryError, message: "Country is required" },
      { value: selectedTimeZone?.zone_name, setter: setTimeZoneError, message: "Time Zone is required" },
      { value: email, setter: setEmailError, message: "Please enter a valid email address", validator: (val: string) => /\S+@\S+\.\S+/.test(val) },
      { value: mobile, setter: setMobileError, message: "Please enter a valid phone number" },
    ];

    let hasError = false;

    fieldsToValidate.forEach(({ value, setter, message, validator }) => {
      if (!value || (validator && !validator(value))) {
        setter(true);
        hasError = true;
      } else {
        setter(false);
      }
    });

    if (hasError) {
      setSnackbarMessage("Please fill in all required fields");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    if (!userData?.data?.id) {
      setSnackbarMessage("User ID is missing");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const timezoneId = selectedTimeZone
      ? timezonesData?.data.timezones
        .flat()
        .find((zone) => zone.zone_name === selectedTimeZone.zone_name)?.id
      : userData?.data?.timezone?.id;

    if (!timezoneId) {
      setSnackbarMessage("Timezone is required");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const payload = {
      id: userData.data.id,
      role_id: role_id || userData.data.role_id,
      role: role || "school",
      first_name: firstName || userData.data.first_name,
      last_name: lastName || userData.data.last_name,
      email: email || userData.data.email,
      isd_code: isd_code || userData.data.isd_code,
      mobile: mobile || userData.data.mobile,
      username: username || userData.data.username,
      secret: secret || userData.data.secret,
      gender: gender || userData.data.gender,
      dob: dob ? dob.toISOString().split("T")[0] : userData.data.dob,
      blood_group: blood_group || userData.data.blood_group,
      timezone: {
        id: timezoneId,
        zone_name: selectedTimeZone?.zone_name || userData.data.timezone!.zone_name,
        country_code: selectedTimeZone?.country_code || userData.data.timezone!.country_code,
      },
      address: {
        city: city! || userData.data.address!.city,
        state: state! || userData.data.address!.state,
        country: selectedCountry?.value || userData.data.address!.country, // Make sure the country is updated here
        zipcode: zipcode! || userData.data.address!.zipcode,
        address1: address1! || userData.data.address!.address1,
        address2: address2! || userData.data.address!.address2,
      },
      country_iso: country_iso! || userData.data.country_iso,
      emergency_contact_info: emergency_contact_info! || userData.data.emergency_contact_info,
      is_2fa: is_2fa! || userData.data.is_2fa,
      is_active: is_active! || userData.data.is_active,
      communication_channel: {
        email: email || userData?.data?.communication_channel?.email || "",
        sms: sms || userData?.data?.communication_channel?.sms || "",
      },
      timezone_id: timezoneId,
    };

    console.log("Payload being sent:", payload);

    try {
      setLoading(true);
      await updateUser(userData.data.id, payload);

      // Success feedback
      setSnackbarMessage("User updated successfully");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      // Fetch the updated user info
      const updatedUser = await fetchUserInfo();
      setUserData(updatedUser);
    } catch (err) {
      console.error("Error updating user:", err);
      setSnackbarMessage("Failed to update user");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center bg-white p-8 mt-4 bg-gray-100 max-h-screen overflow-y-auto">
      <div className="bg-white overflow-y-auto w-full">
        {/* First Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-28">
          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>First Name*</h2>
            <InputField
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
                if (e.target.value.trim()) {
                  setFirstNameError(false);
                }
              }}
              placeholder="First Name"
              disabled={!isEditable}
              showRequiredIndicator={false}
            />
            {firstNameError && (
              <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                First name is required
              </div>
            )}
          </div>
          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>Last Name*</h2>
            <InputField
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
                if (e.target.value.trim()) {
                  setLastNameError(false);
                }
              }}
              placeholder="Last Name"
              disabled={!isEditable}
              showRequiredIndicator={false}
            />
            {lastNameError && (
              <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                Last name is required
              </div>
            )}
          </div>

          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>Blood group*</h2>
            <SelectInput
              selectedValue={blood_group}
              onChange={(value) => {
                setBlood_group(value);
                if (value) {
                  setBloodGroupError(false);
                }
              }}
              options={bloodGroupOptions}
              required
              showRequiredIndicator={false}
            />
            {bloodGroupError && (
              <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                Blood group is required
              </div>
            )}
          </div>
        </div>

        {/* Second Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-28">
          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>Date of Birth*</h2>
            <div className="mt-2">
              <DatePickerInput
                selectedDate={dob}
                onDateChange={(date) => {
                  setDob(date);
                  if (date) {
                    setDobError(false);
                  }
                }}
              />
            </div>
            {dobError && (
              <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                Date of Birth is required
              </div>
            )}
          </div>

          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>Gender*</h2>
            <SelectInput
              selectedValue={gender}
              onChange={(value) => {
                setGender(value);
                if (value) {
                  setGenderError(false);
                }
              }}
              options={genderOptions}
              required
              showRequiredIndicator={false}
            />
            {genderError && (
              <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                Gender is required
              </div>
            )}
          </div>

          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>Address*</h2>
            <InputField
              value={address1}
              onChange={(e) => {
                setAddress1(e.target.value);
                if (e.target.value.trim()) {
                  setAddressError(false);
                }
              }}
              placeholder="123 Main St."
              required
              disabled={!isEditable}
              showRequiredIndicator={false}
            />
            {addressError && (
              <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                Address is required
              </div>
            )}
          </div>
        </div>

        {/* Third Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-28">
          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>Address 2</h2>
            <InputField
              value={address2}
              required
              onChange={(e) => setAddress2(e.target.value)}
              placeholder="Apt, Suite, etc. (optional)"
              disabled={!isEditable}
              showRequiredIndicator={false}
              error={address2Error} // Pass error state to InputField
            />
            {address2Error && (
              <span className="text-red-500 text-sm">
                Address 2 cannot be empty if provided
              </span>
            )}
          </div>

          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>City*</h2>
            <InputField
              value={city}
              onChange={(e) => setCity(e.target.value)}
              placeholder="New York"
              required
              disabled={!isEditable}
              showRequiredIndicator={false}
              error={cityError} // Pass error state to InputField
            />
            {cityError && (
              <span className="text-red-500 text-sm">
                City is required
              </span>
            )}
          </div>

          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>Zipcode*</h2>
            <InputField
              value={zipcode}
              onChange={(e) => setZipcode(e.target.value)}
              placeholder="10001"
              maxLength={6}
              required
              disabled={!isEditable}
              showRequiredIndicator={false}
              error={zipcodeError} // Pass error state to InputField
            />
            {zipcodeError && (
              <span className="text-red-500 text-sm">
                Zipcode is required
              </span>
            )}
          </div>
        </div>

        {/* Fourth Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-28 mt-4">
          {/* State Input */}
          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>State*</h2>
            <Autocomplete
              options={stateOptions}
              value={stateOptions.find((option) => option.value === state) || null}
              onChange={(e, newValue) => setState(newValue ? newValue.value : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  required
                  disabled={!isEditable}
                  fullWidth
                />
              )}
              getOptionLabel={(option) => option.label}
            />
            {stateError && (
              <p style={{ color: "red", fontSize: "12px" }}>State is required.</p>
            )}
          </div>


          {/* Country Input */}
          <div>
            <h2 className="mb-2">Country*</h2>
            <Autocomplete
              options={countryOptions}
              getOptionLabel={(option) => option.label}
              value={selectedCountry ? { label: mastersData?.data.masters.find((master) => master.name === selectedCountry.value)?.name || "Unknown Country", value: selectedCountry.value } : null}
              // value={selectedCountry ? { label: mastersData?.data.masters.find((master) => master.slug === selectedCountry.value)?.name 
              // || "Unknown Country", value: selectedCountry.value } : null}
              onChange={(event, value) => handleCountryChange(value ? value.label : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined" // Ensures box around the input field
                  required
                  disabled={!isEditable}
                  fullWidth


                />
              )}
            />
          </div>

          <div>
            <h2 className="mb-2">Time Zone*</h2>
            <Autocomplete
              options={timeZoneOptions}
              getOptionLabel={(option) => option.label || ""}
              value={selectedTimeZone ? { label: selectedTimeZone.zone_name, value: selectedTimeZone.zone_name } : null}
              onChange={(event, value) => {
                setSelectedTimeZone(value ? { zone_name: value.value, country_code: selectedCountry?.value || "" } : null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined" // Ensures box around the input field
                  required
                  disabled={!selectedCountry || !isEditable}
                  fullWidth
                />
              )}
            />
          </div>
        </div>

        {/* Fifth Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-28">
          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>Phone Number*</h2>
            <div className="mt-2">
              <PhoneNumberInput
                selectedCountry={selectedCountry}
                isdCode={isdCode}
                setIsdCode={setIsdCode}
                mobile={mobile}
                setmobile={setmobile}
                disabled={isEditable}
                showRequiredIndicator={false}
              />
            </div>
            {mobileError && (
              <p className="text-red-500 text-sm mt-1">Please enter a valid phone number</p>
            )}
          </div>

          <div>
            <h2 style={{ fontFamily: "Jost, sans-serif", color: "gray" }}>Email*</h2>
            <InputField
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="example@example.com"
              required
              type="email"
              disabled={!isEditable}
              showRequiredIndicator={false}
            />
            {emailError && (
              <p className="text-red-500 text-sm mt-1">Please enter a valid email address</p>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-4 mt-8 w-full">
          <CustomButton onClick={handleCancel} color="secondary">
            Cancel
          </CustomButton>
          <CustomButton onClick={handleSave} color="primary">
            Update
          </CustomButton>
        </div>
      </div>
      {error && <p className="text-red-500">{error}</p>}
      <SnackbarMessage
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={() => setSnackbarOpen(false)}
      />
    </div>

  );
}
export default Accounts;
